<div class="dialog-content-max">
  <form [formGroup]="ConfigurationForm" *ngIf="loginuserid==0 && !isEdit">
    <div class="p-field">
      <div class="field col-2">
        <label for="mainKey" class="required-label">Main Key<span class="maxchars">(Max 4 digits)</span><span>*</span></label>
        <input (input)="onMainKeyInput($event)" maxlength="4" type="number" class="form-control" id="mainKey" placeholder="Enter Main Key" name="mainkey"
          formControlName="mainkey" required>
        <span class="errormessage"
          *ngIf="ConfigurationForm.get('mainkey').invalid && (ConfigurationForm.get('mainkey').dirty || ConfigurationForm.get('mainkey').touched)">
          {{getErrorMessage(ConfigurationForm,validation_message,'mainkey')}}
        </span>

      </div>
    </div>

    <p-accordion [activeIndex]="0">
      <p-accordionTab header="Configuration Details">
        <div class="innerformarray">

          <div class="grid">
            <div class="col-12 md:col-2 lg:col-2 sm:col-12">
              <button pButton (click)="addNewRow()" class="customeadd" type="button">Add Row</button>
            </div>
          </div>

          <div class="grid">

            <div class="table-responsive col-12">
              <table class="table table-bordered">
                <thead>
                  <tr class="thead-row">
                    <th><label class="required-label" style="color:white">Sub Key<span>*</span></label> </th>
                    <th> <label class="required-label" style="color:white">Data Type <span>*</span></label> </th>
                    <th class="title-col">
                      <label class="required-label" style="color:white">
                        Title<span class="maxchars">(Max 300 chars)</span><span>*</span>
                      </label>
                    </th>

                    <!-- <th class="keyvalue-col">
                      <label class="required-label" style="color:white">
                        Key Value add modal<span>*</span>
                      </label>
                    </th> -->

                    <th class="keyvalue-col">
                      <label class="required-label" style="color:white">
                        Key Value
                        <span class="maxchars" *ngIf="isAnyRowTextType()">
                          (Max 1000 chars)
                        </span>
                        <span>*</span>
                      </label>
                    </th>

                    <th class="description-col">
                      <label class="required-label" style="color:white">
                        Description<span class="maxchars">(Max 1000 chars)</span><span>*</span>
                      </label>
                    </th>
                    <th> <label class="required-label" style="color:white">Product<span>*</span></label></th>
                    <th class="col-small">
                      <label class="required-label" style="color:white">PMS Show <span>*</span></label>
                    </th>
                    <th class="col-small">
                      <label class="required-label" style="color:white">PMS Edit <span>*</span></label>
                    </th>
                    <th class="col-small">
                      <label class="required-label" style="color:white">SELF Show <span>*</span></label>
                    </th>
                    <th class="col-small">
                      <label class="required-label" style="color:white">SELF Edit <span>*</span></label>
                    </th>

                    <th class="col-small" *ngIf="!onlyView && formArr.controls.length > 1">Delete Row</th>
                  </tr>
                </thead>
                <tbody formArrayName="Rows">
                  <tr *ngFor="let itemrow of formArr.controls; let i = index" [formGroupName]="i">
                    <td><input type="number" (input)="onSubKeyInput($event)" class="form-control"
                        placeholder="Enter Sub Key" formControlName="subKey" maxlength="2">
                      <span style="color:red"
                        *ngIf="itemrow.get('subKey').invalid && (itemrow.get('subKey').touched ||itemrow.get('subKey').dirty )">
                        {{getErrorMessage(itemrow,validation_message,'subKey')}}
                      </span>
                    </td>
                    <td><p-dropdown [options]="datatypelist" optionLabel="label" optionValue="value"
                        formControlName="dataType" appendTo="body"></p-dropdown>
                      <span class="errormessage"
                        *ngIf="itemrow.get('dataType').invalid && itemrow.get('dataType').touched ">
                        {{getErrorMessage(itemrow,validation_message,'dataType')}}
                      </span>
                    </td>
                    <td class="title-col"><textarea [autoResize]="true" class="form-control" formControlName="title"
                        placeholder="Enter Title" pInputTextarea></textarea>
                      <span class="errormessage"
                        *ngIf="itemrow.get('title').invalid && (itemrow.get('title').touched ||itemrow.get('title').dirty )">
                        {{getErrorMessage(itemrow,validation_message,'title')}}
                      </span>
                    </td>
                    <td class="keyvalue-col">
                      <textarea [autoResize]="true"
                        *ngIf="itemrow.get('dataType').value==''|| itemrow.get('dataType').value=='Text'"
                        class="form-control" formControlName="keyValue" placeholder="Enter Key Value"
                        pInputTextarea></textarea>
                      <input *ngIf="itemrow.get('dataType').value=='Numeric'" type="number" class="form-control"
                        formControlName="keyValue" placeholder="Enter Key Value">
                      <p-dropdown *ngIf="itemrow.get('dataType').value=='Flag Type'" [options]="yesnolist"
                        optionLabel="label" optionValue="value" formControlName="keyValue" appendTo="body"></p-dropdown>
                      <span class="errormessage"
                        *ngIf="itemrow.get('keyValue').invalid && (itemrow.get('keyValue').touched ||itemrow.get('keyValue').dirty )">
                        {{getErrorMessage(itemrow,validation_message,'keyValue')}}
                      </span>
                    </td>
                    <td class="description-col"><textarea [autoResize]="true" class="form-control"
                        formControlName="description" placeholder="Enter Description" pInputTextarea></textarea>
                      <span class="errormessage"
                        *ngIf="itemrow.get('description').invalid && (itemrow.get('description').touched ||itemrow.get('description').dirty )">
                        {{getErrorMessage(itemrow,validation_message,'description')}}
                      </span>
                    </td>
                    <td>
                      <p-dropdown [filter]="true" [resetFilterOnHide]="true"
                        [pTooltip]="getSelectedProductName(itemrow)" [options]="productlist" optionLabel="productname"
                        optionValue="productid" formControlName="product" appendTo="body"></p-dropdown>
                      <span class="errormessage"
                        *ngIf="itemrow.get('product').invalid && itemrow.get('product').touched ">
                        {{getErrorMessage(itemrow,validation_message,'product')}}
                      </span>
                    </td>
                    <td class="col-small"><p-dropdown [options]="yesnolist" optionLabel="label" optionValue="value"
                        formControlName="pmsShow" appendTo="body"></p-dropdown>
                      <span class="errormessage"
                        *ngIf="itemrow.get('pmsShow').invalid && itemrow.get('pmsShow').touched ">
                        {{getErrorMessage(itemrow,validation_message,'pmsShow')}}
                      </span>
                    </td>
                    <td class="col-small"><p-dropdown [options]="yesnolist" optionLabel="label" optionValue="value"
                        formControlName="pmsEdit" appendTo="body"></p-dropdown>
                      <span class="errormessage"
                        *ngIf="itemrow.get('pmsEdit').invalid && itemrow.get('pmsEdit').touched ">
                        {{getErrorMessage(itemrow,validation_message,'pmsEdit')}}
                      </span>
                    </td>
                    <td class="col-small"><p-dropdown [options]="yesnolist" optionLabel="label" optionValue="value"
                        formControlName="selfShow" appendTo="body"></p-dropdown>
                      <span class="errormessage"
                        *ngIf="itemrow.get('selfShow').invalid && (itemrow.get('selfShow').touched )">
                        {{getErrorMessage(itemrow,validation_message,'selfShow')}}
                      </span>
                    </td>
                    <td class="col-small"><p-dropdown [options]="yesnolist" optionLabel="label" optionValue="value"
                        formControlName="selfEdit" appendTo="body"></p-dropdown>
                      <span class="errormessage"
                        *ngIf="itemrow.get('selfEdit').invalid && itemrow.get('selfEdit').touched ">
                        {{getErrorMessage(itemrow,validation_message,'selfEdit')}}
                      </span>
                    </td>
                    <td *ngIf="!onlyView && formArr.controls.length > 1"
                      style="text-align:center; vertical-align:middle;">
                      <i class="p-element fa fa-trash-o red-icon ng-star-inserted" (click)="deleteRow(i)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>


          </div>
        </div>

      </p-accordionTab>
    </p-accordion>
  </form>
  <form [formGroup]="modifyform" *ngIf="loginuserid==0 && isEdit">
    <div class="formgrid grid">
      <div class="field col-12 md:col-3 lg:col-3 sm:col-12">
        <label for="product" class="required-label">Product<span>*</span></label>
        <p-dropdown [filter]="true" [resetFilterOnHide]="true" [options]="productlist" optionLabel="productname"
          optionValue="productid" formControlName="product" appendTo="body"
          [pTooltip]="getSelectedProductNameModify()"></p-dropdown>
        <span style="color:red" *ngIf="modifyform.get('product').invalid && modifyform.get('product').touched ">
          {{getErrorMessage(modifyform,validation_message,'product')}}
        </span>
      </div>
      <div class="field col-12 md:col-3 lg:col-3 sm:col-12">
        <label for="mainKey" class="required-label">Data Type<span>*</span></label>
        <p-dropdown [options]="datatypelist" optionLabel="label" optionValue="value" formControlName="dataType"
          appendTo="body"></p-dropdown>
        <span style="color:red" *ngIf="modifyform.get('dataType').invalid && modifyform.get('dataType').touched ">
          {{getErrorMessage(modifyform,validation_message,'dataType')}}
        </span>
      </div>
    </div>
    <div class="formgrid grid">
      <div class="field col-12">
        <label for="mainKey" class="required-label">Title<span class="maxchars">(Max 300
            chars)</span><span>*</span></label>
        <textarea class="form-control" formControlName="title" placeholder="Enter Title" pInputTextarea [autoResize]="true"></textarea>
        <span style="color:red"
          *ngIf="modifyform.get('title').invalid && (modifyform.get('title').touched ||modifyform.get('title').dirty ) ">
          {{getErrorMessage(modifyform,validation_message,'title')}}
        </span>
      </div>
    </div>
    <div class="formgrid grid">
      <div class="field" [ngClass]="modifyform.get('dataType').value == 'Text' ? 'col-12' : 'col-3'">

        <label for="keyValue" class="required-label">
          Key Value
          <span *ngIf="modifyform.get('dataType').value=='' || modifyform.get('dataType').value=='Text'"
            class="maxchars">(Max 1000 chars)</span>
          <span>*</span>
        </label>

        <textarea *ngIf="modifyform.get('dataType').value=='' || modifyform.get('dataType').value=='Text'"
          class="form-control" formControlName="keyValue" placeholder="Enter Key Value" pInputTextarea [autoResize]="true">
    </textarea>

        <input *ngIf="modifyform.get('dataType').value=='Numeric'" type="number" class="form-control"
          formControlName="keyValue" placeholder="Enter Key Value">

        <p-dropdown *ngIf="modifyform.get('dataType').value=='Flag Type'" [options]="yesnolist" optionLabel="label"
          optionValue="value" formControlName="keyValue" appendTo="body">
        </p-dropdown>

        <span style="color:red"
          *ngIf="modifyform.get('keyValue').invalid && (modifyform.get('keyValue').touched || modifyform.get('keyValue').dirty)">
          {{getErrorMessage(modifyform,validation_message,'keyValue')}}
        </span>

      </div>
    </div>
    <div class="formgrid grid">
      <div class="field col-12">
        <label for="description" class="required-label">Description<span class="maxchars">(Max 1000
            chars)</span><span>*</span></label>
        <textarea [autoResize]="true" class="form-control" formControlName="description" placeholder="Enter Description"
          pInputTextarea></textarea>
        <span style="color:red"
          *ngIf="modifyform.get('description').invalid && (modifyform.get('description').touched ||modifyform.get('description').dirty )  ">
          {{getErrorMessage(modifyform,validation_message,'description')}}
        </span>
      </div>
    </div>

    <div class="formgrid grid">

      <div class="field col-12 md:col-3 lg:col-3 sm:col-12">
        <label for="pmsShow" class="required-label">PMS Show<span>*</span></label>
        <p-dropdown [options]="yesnolist" optionLabel="label" optionValue="value" formControlName="pmsShow"
          appendTo="body"></p-dropdown>
        <span style="color:red" *ngIf="modifyform.get('pmsShow').invalid && modifyform.get('pmsShow').touched ">
          {{getErrorMessage(modifyform,validation_message,'pmsShow')}}
        </span>
      </div>

      <div class="field col-12 md:col-3 lg:col-3 sm:col-12">
        <label for="pmsEdit" class="required-label">PMS Edit<span>*</span></label>
        <p-dropdown [options]="yesnolist" optionLabel="label" optionValue="value" formControlName="pmsEdit"
          appendTo="body"></p-dropdown>
        <span style="color:red" *ngIf="modifyform.get('pmsEdit').invalid && modifyform.get('pmsEdit').touched ">
          {{getErrorMessage(modifyform,validation_message,'pmsEdit')}}
        </span>
      </div>

      <div class="field col-12 md:col-3 lg:col-3 sm:col-12">
        <label for="selfShow" class="required-label">SELF Show<span>*</span></label>
        <p-dropdown [options]="yesnolist" optionLabel="label" optionValue="value" formControlName="selfShow"
          appendTo="body"></p-dropdown>
        <span style="color:red" *ngIf="modifyform.get('selfShow').invalid && modifyform.get('selfShow').touched ">
          {{getErrorMessage(modifyform,validation_message,'selfShow')}}
        </span>
      </div>

      <div class="field col-12 md:col-3 lg:col-3 sm:col-12">
        <label for="selfEdit" class="required-label">SELF Edit<span>*</span></label>
        <p-dropdown [options]="yesnolist" optionLabel="label" optionValue="value" formControlName="selfEdit"
          appendTo="body"></p-dropdown>
        <span style="color:red" *ngIf="modifyform.get('selfEdit').invalid && modifyform.get('selfEdit').touched ">
          {{getErrorMessage(modifyform,validation_message,'selfEdit')}}
        </span>
      </div>

    </div>


  </form>

  <form [formGroup]="modifyform" *ngIf="loginuserid!==0 && isEdit">
    <div class="formgrid grid">
      <div class="field col-12">
        <label for="keyValue" class="required-label">Key Value<span class="maxchars" *ngIf="modifyform.get('dataType').value=='Text'">
                          (Max 1000 chars)
                        </span><span>*</span></label>
        <textarea *ngIf="modifyform.get('dataType').value=='Text'" class="form-control" formControlName="keyValue"
          placeholder="Enter Key Value" pInputTextarea  [autoResize]="true"></textarea>
        <input *ngIf="modifyform.get('dataType').value=='Numeric'" type="number" class="form-control"
          formControlName="keyValue" placeholder="Enter Key Value">
        <p-dropdown *ngIf="modifyform.get('dataType').value=='Flag Type'" [options]="yesnolist" optionLabel="label"
          optionValue="value" formControlName="keyValue" appendTo="body"></p-dropdown>
        <span style="color:red"
          *ngIf="modifyform.get('keyValue').invalid && (modifyform.get('keyValue').touched || modifyform.get('keyValue').dirty)">
          {{getErrorMessage(modifyform,validation_message,'keyValue')}}
        </span>

      </div>

    </div>
    <div class="formgrid grid">
      <div class="field col-12">
        <label for="keyValue" class="required-label">Description</label>
        <textarea [autoResize]="true" class="form-control" formControlName="description" placeholder="Enter Description"
          pInputTextarea readonly></textarea>

      </div>

    </div>

  </form>
</div>
<div class="custom-dialog-footer">
  <p-button *ngIf="!isEdit" class="m-1" label="Close" styleClass="customeclose"
    (click)="closemodal(ConfigurationForm,this.ref,'Are you sure you want to close?')"></p-button>
  <p-button *ngIf="isEdit" class="m-1" label="Close" styleClass="customeclose"
    (click)="closemodal(modifyform,this.ref,'Are you sure you want to close?')"></p-button>
  <p-button *ngIf="!isEdit" class="m-1" label="{{saveTitle}}" styleClass="customesave" (click)="save()"></p-button>
  <p-button *ngIf="isEdit" class="m-1" label="{{saveTitle}}" styleClass="customesave" (click)="modify()"></p-button>
</div>